import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Portal from '../Components/Portal';
import { WSEvents } from '../constants/ws';
import { useWebSocketContext } from '../providers/WebSocketProvider';
import { useAppSelector } from '../store';
import LoadingDots from '../assets/svg/utils/loading/loading-dots.svg';

function EstablishConnectionModal() {
  const { webSocket } = useWebSocketContext();
  const { activeGame } = useAppSelector(({ aviator }) => aviator);

  const [connected, setConnected] = useState(webSocket.server?.readyState === WebSocket.OPEN);

  useEffect(() => {
    const onConnected = () => {
      setConnected(true);
    };

    const onConnecting = () => {
      setConnected(false);
    };

    window.addEventListener(WSEvents.CONNECTING, onConnecting);
    window.addEventListener(WSEvents.CONNECTED, onConnected);

    return () => {
      window.removeEventListener(WSEvents.CONNECTING, onConnecting);
      window.removeEventListener(WSEvents.CONNECTED, onConnected);
      webSocket.cleanup();
    };
  }, []);

  if (connected || activeGame === 'aviator') {
    return null;
  }

  return (
    <Portal>
      <div className="fixed inset-0 p-6 bg-black bg-opacity-80 flex flex-col justify-center items-center z-[5000] text-white">
        <motion.img
          src={LoadingDots}
          alt="loader"
          animate={{ rotate: 360 }}
          transition={{
            duration: 1, repeat: Infinity, ease: 'linear', repeatType: 'loop',
          }}
        />
        <p className="text-lg font-Bangers">
          Establishing connection
        </p>
        <p className="text-sm font-Barlow">It will take a few moments...</p>
      </div>
    </Portal>
  );
}

export default EstablishConnectionModal;
